import PromiseRender from './PromiseRender';

export default PromiseRender;
